export default __webpack_public_path__ + "static/media/zelcore.c99d622a.jpeg";